import styled from '@emotion/styled';
import React from 'react';

import {
    STATIC_MAP_HEIGHT,
    STATIC_MAP_MARKER_ICON,
    STATIC_MAP_SCALE,
    STATIC_MAP_STYLES,
    STATIC_MAP_ZOOM,
} from './constants';
import { getStaticMapURL } from './utils';

export interface StaticMapProps {
    latitude: string;
    longitude: string;
    location: string;
}

export enum StaticMapIds {
    Container = 'StaticMapContainer',
}

export const StaticMap = ({
    latitude,
    longitude,
    location,
}: StaticMapProps) => {
    const [width, setWidth] = React.useState(0);
    const handleRef = (node: HTMLDivElement) => {
        if (node && node.clientWidth && node.clientWidth !== width) {
            setWidth(node.clientWidth);
        }
    };

    const center = `${latitude},${longitude}`;
    const height = STATIC_MAP_HEIGHT;
    let imageSrc;

    if (width > 0) {
        const markers = `scale:${STATIC_MAP_SCALE}|icon:${STATIC_MAP_MARKER_ICON}|${center}`;

        imageSrc = getStaticMapURL({
            center,
            markers,
            zoom: STATIC_MAP_ZOOM,
            width,
            height,
            scale: STATIC_MAP_SCALE,
            styles: STATIC_MAP_STYLES,
        });
    }

    return (
        <Container
            height={height}
            ref={handleRef}
            data-testid={StaticMapIds.Container}
        >
            {imageSrc && <Image src={imageSrc} alt={location} />}
        </Container>
    );
};

const Container = styled.div<{ height: number }>`
    border-radius: 8px;
    overflow: hidden;
    height: ${(props) => props.height}px;
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;
